export class LinxoRedirectStatus {
  static AUTHORIZED = "AUTHORIZED";
  static SUCCESS = "SUCCESS";
  static FAILED = "FAILED";
}

export class LinxoUsage {
  static ADD_CONNECTION = "add_connection";
  static MANAGE_CONNECTIONS = "manage_connections";
  static EDIT_CREDENTIALS = "edit_credentials";
  static MANAGE_ACCOUNTS = "manage_accounts";
}

export class BankProvider {
  static NORDIGEN = "nordigen";
  static LINXO = "linxo";
}
